import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function SupplierConcentrationCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.mgmtConcentrationChart !== 'undefined') {
      window.mgmtConcentrationChart.canvas = chartRef.current;
      window.mgmtConcentrationChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Supplier Concentration (Top 5 = 63%)</h3>
        <span className="click-tag">Click bars for vendor 360°</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="mgmtConcentrationChart" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
